"use client";
import cn from "clsx";
import { useState, useEffect } from "react";
import { getCookie, getDefaultScreenStr, setCookie } from "@/util/cookies";
import * as Select from "@radix-ui/react-select";
import { Flex } from "@radix-ui/themes";

import Icon from "@/components/common/icon/icon";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
import { Debug } from "@/util/debug";
const screen_list = {
  N: {
    icon: "Table",
    value: "N",
    className: "group-hover:animate-flip-down",
  },
  S: {
    icon: "SidebarSimple",
    value: "S",
    className: "group-hover:animate-flip-up",
  },
  F: {
    icon: "CornersOut",
    value: "F",
    className: "group-hover:animate-jump",
  },
};

export default function ScreenButton({
  className,
  screenType,
  setScreenType,
}: {
  className?: string;
  screenType?: string;
  setScreenType?: Function;
}) {
  const [screen, setScreen] = useState(screenType ?? "");

  //값이 변경될때
  useEffect(() => {
    if (typeof window === "object" && document !== null) {
      const defaultScreen = getDefaultScreenStr();

      const in_menu_str = getCookie("screen") ?? defaultScreen;
      // Debug("screen", in_menu_str, screen);
      if (screen === "" && in_menu_str !== null) {
        setScreen(in_menu_str);
      } else {
        setCookie("screen", screen, 30, "/");
        if (screen !== in_menu_str) {
          document.body.style.overflow = "hidden";
          if (screen == "F") {
            document.body.classList.remove("screenSimple");
            document.body.classList.add("screenFull");
          } else if (screen == "S") {
            document.body.classList.remove("screenFull");
            document.body.classList.add("screenSimple");
          } else {
            document.body.classList.remove("screenSimple");
            document.body.classList.remove("screenFull");
          }
          setTimeout(function () {
            document.body.style.removeProperty("overflow");
          }, 1000);
        }
        if (setScreenType && screenType !== screen) {
          setScreenType(screen);
        }
      }
    }
  }, [screen, screenType, setScreenType]);

  return (
    <Flex direction="column" className={cn(className, "")}>
      <Select.Root value={screen} onValueChange={setScreen} name="tool_screen_button">
        <Select.Trigger className="outline-0" id="tool_screen_button" aria-label="Tool Screen Button">
          <Flex id="themeState" align="center" gap="2" className="p-1 group">
            {Object.values(screen_list).map((item, index) => {
              return (
                <Icon
                  key={"screenButtonShow_" + index}
                  iconType="phosphor"
                  iconName={item.icon}
                  className={cn("w-5 h-5", item.value == screen ? "screenType" + screen : "hidden", item.className)}
                />
              );
            })}
          </Flex>
        </Select.Trigger>
        <Select.Content position="popper">
          {Object.values(screen_list).map((item, index) => {
            return (
              <Select.Item
                key={"screenButtonSelect_" + index}
                value={item.value}
                className={cn(screen == item.value ? "hidden" : "", "cursor-pointer mt-1 p-1 outline-amber-500 group")}
              >
                <Icon iconType="phosphor" iconName={item.icon} className={cn(item.className, "w-5 h-5")} />
              </Select.Item>
            );
          })}
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
